document.addEventListener("DOMContentLoaded", function () {

    if (window.innerWidth >= 750) return;

    const target = document.getElementById("mobile-product-summary");
    const details = document.querySelector(".product-details .group-block-content");

    if (!target || !details) return;

    // Find the first accordion
    const firstAccordion = details.querySelector(".accordion");

    if (!firstAccordion) return;

    // Move everything before the accordion
    while (details.firstElementChild && details.firstElementChild !== firstAccordion) {
        target.appendChild(details.firstElementChild);
    }

});